import { render, staticRenderFns } from "./ColaA.vue?vue&type=template&id=fc0a22fa&scoped=true"
import script from "./ColaA.vue?vue&type=script&lang=js"
export * from "./ColaA.vue?vue&type=script&lang=js"
import style0 from "./ColaA.vue?vue&type=style&index=0&id=fc0a22fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0a22fa",
  null
  
)

export default component.exports